/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ItemInstanceRef,
  ItemInstanceRefOptional,
  ItemInstanceRefMetaI,
  ItemInstanceRefTrackedI,
} from "./item-instance-ref";
import {
  ItemInstanceRefTracked,
  ItemInstanceRefMeta,
} from "./item-instance-ref";

/**
 *
 * @export
 * @interface PricingInformationDTO
 */
export interface PricingInformationDTOOptional {
  /**
   *
   * @type {ItemInstanceRef}
   * @memberof PricingInformationDTO
   */
  catalogItemInstance?: ItemInstanceRefOptional;
  /**
   *
   * @type {number}
   * @memberof PricingInformationDTO
   */
  catalogPriceCents?: number;
}

export interface PricingInformationDTO extends PricingInformationDTOOptional {
  /**
   *
   * @type {ItemInstanceRef}
   * @memberof PricingInformationDTO
   */
  catalogItemInstance?: ItemInstanceRef;
  /**
   *
   * @type {number}
   * @memberof PricingInformationDTO
   */
  catalogPriceCents?: number;
}

export interface PricingInformationDTOTrackedI {
  /**
   *
   * @type {ItemInstanceRef}
   * @memberof PricingInformationDTO
   */
  catalogItemInstance?: ItemInstanceRefTrackedI;
  catalogItemInstanceIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PricingInformationDTO
   */
  catalogPriceCents?: number;
  catalogPriceCentsIsSet: boolean;
}

transformDatesMap.set(
  "PricingInformationDTO",
  function (model: PricingInformationDTO) {
    const transformDatescatalogItemInstance =
      transformDatesMap.get("ItemInstanceRef");
    if (transformDatescatalogItemInstance && model.catalogItemInstance) {
      transformDatescatalogItemInstance(model.catalogItemInstance);
    }
  },
);

export type PricingInformationDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  catalogItemInstance: PropertyMeta<ItemInstanceRefMetaI>;
  //isDate: false
  //isDatetime: false
  catalogPriceCents: PropertyMeta<MetaTypeBase<number>>;
}>;

export var PricingInformationDTOMeta: PricingInformationDTOMetaI =
  {} as PricingInformationDTOMetaI;
PricingInformationDTOMeta = typeMeta("PricingInformationDTO", {
  catalogItemInstance: propertyMeta(
    "catalogItemInstance",
    false,
    false,
    false,
    ItemInstanceRefMeta,
  ),
  catalogPriceCents: propertyMeta(
    "catalogPriceCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = PricingInformationDTOMeta;

registerMeta(() => {});

export class PricingInformationDTOTracked implements PricingInformationDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  catalogItemInstance__I?: ItemInstanceRefTracked = undefined;
  catalogItemInstanceIsSet: boolean = false;
  set catalogItemInstance(v: undefined | ItemInstanceRefTracked) {
    if (v !== undefined) {
      this.catalogItemInstance__I = v;
      this.catalogItemInstanceIsSet = true;
    } else {
      this.catalogItemInstance__I = v || undefined;
      this.catalogItemInstanceIsSet = false;
    }
    this.changeTracker = true;
  }
  get catalogItemInstance() {
    return this.catalogItemInstance__I;
  }
  catalogPriceCents__I?: number = undefined;
  catalogPriceCentsIsSet: boolean = false;
  set catalogPriceCents(v: undefined | number) {
    if (v !== undefined) {
      this.catalogPriceCents__I = v;
      this.catalogPriceCentsIsSet = true;
    } else {
      this.catalogPriceCents__I = v || undefined;
      this.catalogPriceCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get catalogPriceCents() {
    return this.catalogPriceCents__I;
  }
  constructor(config?: PricingInformationDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.catalogItemInstance?.setIds();
  }
  assignFrom(
    config: PricingInformationDTOOptional,
    options?: AssignOptions,
  ): PricingInformationDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.catalogItemInstance &&
      this.catalogItemInstanceApplyFilter(optionsRequired.filter)
    ) {
      this.catalogItemInstance = new ItemInstanceRefTracked(
        config.catalogItemInstance,
        options,
      );
      if (optionsRequired.unassign) this.catalogItemInstanceIsSet = false;
      else this.catalogItemInstanceIsSet = true;
    }
    if (
      config.catalogPriceCents &&
      this.catalogPriceCentsApplyFilter(optionsRequired.filter)
    ) {
      this.catalogPriceCents = config.catalogPriceCents;
      if (optionsRequired.unassign) this.catalogPriceCentsIsSet = false;
      else this.catalogPriceCentsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PricingInformationDTOTrackedI {
    const cloned = {} as PricingInformationDTOTrackedI;
    if (
      this.catalogItemInstanceIsSetDeep() &&
      this.catalogItemInstanceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.catalogItemInstanceIsSet = true;
      cloned.catalogItemInstance =
        this.catalogItemInstance?.removeUnset(filter);
    } else {
      //cloned.catalogItemInstanceIsSet = false
    }
    if (
      this.catalogPriceCentsIsSetDeep() &&
      this.catalogPriceCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.catalogPriceCentsIsSet = true;
      cloned.catalogPriceCents = this.catalogPriceCents;
    } else {
      //cloned.catalogPriceCentsIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PricingInformationDTOTrackedI {
    if (!this.catalogItemInstanceApplyFilter(filter))
      this.catalogItemInstanceIsSet = false;
    this.catalogItemInstance?.unassignAll(filter);

    if (!this.catalogPriceCentsApplyFilter(filter))
      this.catalogPriceCentsIsSet = false;

    return this;
  }
  catalogItemInstanceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PricingInformationDTOMeta.catalogItemInstance,
      PricingInformationDTOMeta,
      this.catalogItemInstance,
      this,
    );
  }
  catalogItemInstanceIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.catalogItemInstanceIsSet &&
      this.catalogItemInstanceApplyFilter(filter)
    )
      return true;
    return this.catalogItemInstance?.anySet(filter) == true;

    return false;
  }
  catalogPriceCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PricingInformationDTOMeta.catalogPriceCents,
      PricingInformationDTOMeta,
      this.catalogPriceCents,
      this,
    );
  }
  catalogPriceCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.catalogPriceCentsIsSet &&
      this.catalogPriceCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.catalogItemInstanceIsSetDeep(filter)) return true;
    if (this.catalogPriceCentsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
